import base from "../../baseurl";
import token from "../../getTk";

const Create = async (name, background, id) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("sport-document-types/update", {
      json: { name, background, id },
      timeout: false,
    })
    .json();
  return newS;
};

export default Create;
